import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { FormattedMessage } from 'react-intl'

import GroupMonitoringForm from './components/GroupMonitoringForm'
import hocDialogComponent from '../../../../services/dialog/hocDialogComponent'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
@hocDialogComponent
export default class GroupMembersImport extends Component {
    static propTypes = {
        activeGroup: IPropTypes.map.isRequired,
        addGroupMonitoring: PropTypes.func.isRequired,
        closeDialog: PropTypes.func.isRequired,
        groupMonitoring: IPropTypes.record.isRequired,
        initializeGroupMonitoringDialog: PropTypes.func.isRequired,
        sendingFrequency: PropTypes.string.isRequired,
        userEmail: PropTypes.string.isRequired,
    }

    componentDidMount() {
        const { initializeGroupMonitoringDialog } = this.props

        initializeGroupMonitoringDialog()
    }

    onButtonClick = (buttonType) => {
        const { closeDialog, addGroupMonitoring } = this.props
        if (buttonType === 'close') {
            closeDialog('groupMonitoring')
        }

        if (buttonType === 'save') {
            addGroupMonitoring()
        }
    }

    getLoadingMessage = () => {
        const {
            groupMonitoring: { groupMonitoringData },
            activeGroup: { name },
        } = this.props

        return groupMonitoringData.isEmpty() ? (
            <FormattedMessage id={`${LOCALE_PREFIX}.loadingMessage`} values={{ groupName: name }} />
        ) : (
            <FormattedMessage id={`${LOCALE_PREFIX}.updatingMessage`} values={{ groupName: name }} />
        )
    }

    defineHeader = () => ({
        text: (
            <FormattedMessage
                id={`${LOCALE_PREFIX}.headerTitle`}
                values={{ groupName: this.props.activeGroup.get('name') }}
            />
        ),
        icon: 'import',
    })

    defineFooter = () => {
        const {
            groupMonitoring: { loading },
        } = this.props

        return !loading
            ? [
                  {
                      type: 'close',
                      text: <FormattedMessage id={`${LOCALE_PREFIX}.close`} />,
                  },
                  {
                      type: 'save',
                      text: <FormattedMessage id={`${LOCALE_PREFIX}.save`} />,
                  },
              ]
            : []
    }

    render() {
        const {
            groupMonitoring: { loading },
            userEmail,
            sendingFrequency,
        } = this.props

        return loading ? (
            <div className={'group-monitoring'}>
                <div className={'loader-wrap'}>
                    <div className={'text'}>{this.getLoadingMessage()}</div>
                    <div className={'loader'} />
                </div>
            </div>
        ) : (
            <GroupMonitoringForm
                initialValues={{
                    sendingFrequency: 'daily',
                    sendingMethod: 'INLINE_HTML',
                    recipients: [{ label: userEmail, value: userEmail }],
                }}
                sendingFrequency={sendingFrequency}
            />
        )
    }
}
